export const IntroReferences = {
  RefSection1Intro01: "01sec01i",
  RefSection2Intro01: "02sec01i",
  RefSection3Intro01: "03sec01i",
  RefSection4Intro01: "04sec01i",
  RefSection5Intro01: "05sec01i",
  RefSection6Intro01: "06sec01i",
}

export const ExplReferences = {
  RefSection2Expl01: "02sec01expl",
  RefSection2Expl02: "02sec02expl",
  RefSection2Expl03: "02sec03expl",
  RefSection2Expl04: "02sec04expl",
  RefSection2Expl05: "02sec05expl",
  RefSection2Expl06: "02sec06expl",
  RefSection2Expl07: "02sec07expl",
  RefSection2Expl08: "02sec08expl",
  RefSection2Expl09: "02sec09expl",
  RefSection2Expl10: "02sec10expl",
  RefSection2Expl11: "02sec11expl",
  RefSection2Expl12: "02sec12expl",
  RefSection2Expl13: "02sec13expl",
  RefSection3Expl01: "03sec01expl",
  RefSection3Expl02: "03sec02expl",
  RefSection3Expl03: "03sec03expl",
  RefSection3Expl04: "03sec04expl",
  RefSection3Expl05: "03sec05expl",
  RefSection3Expl06: "03sec06expl",
  RefSection3Expl07: "03sec07expl",
  RefSection3Expl08: "03sec08expl",
  RefSection3Expl09: "03sec09expl",
  RefSection3Expl10: "03sec10expl",
  RefSection3Expl11: "03sec11expl",
  RefSection3Expl12: "03sec12expl",
  RefSection3Expl13: "03sec13expl",
  RefSection4Expl01: "04sec01expl",
  RefSection4Expl02: "04sec02expl",
  RefSection4Expl03: "04sec03expl",
  RefSection4Expl04: "04sec04expl",
  RefSection4Expl05: "04sec05expl",
  RefSection4Expl06: "04sec06expl",
  RefSection4Expl07: "04sec07expl",
  RefSection4Expl08: "04sec08expl",
  RefSection4Expl09: "04sec09expl",
  RefSection5Expl01: "05sec01expl",
  RefSection5Expl02: "05sec02expl",
  RefSection5Expl03: "05sec03expl",
  RefSection5Expl04: "05sec04expl",
  RefSection5Expl05: "05sec05expl",
  RefSection5Expl06: "05sec06expl",
  RefSection5Expl07: "05sec07expl",
  RefSection5Expl08: "05sec08expl",
  RefSection5Expl09: "05sec09expl",
  RefSection5Expl10: "05sec10expl",
  RefSection5Expl11: "05sec11expl",
  RefSection5Expl12: "05sec12expl",
  RefSection5Expl13: "05sec13expl",
}

export const EndReferences = {
  RefSection1End01: "01sec01end",
  RefSection2End01: "02sec01end",
  RefSection3End01: "03sec01end",
  RefSection4End01: "04sec01end",
  RefSection5End01: "05sec01end",
  RefSection6End01: "06sec01end",
  RefSection6End02: "06sec02end",
}

